<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.push('/egresos')">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>
      <b-card-header class="border-0">
        <div>
          <h3 v-if="egreso && estadoEgresoOptions.length" class="d-flex justify-content-center w-100 mb-0">
            <b-badge class="badge-lg"
              :variant="['info', 'warning', 'success'][egreso && estadoEgresoOptions.length ? [7, 10, 13].includes(egreso.estadoID) ? 0 : [1, 2, 3, 4, 5, 14,15].includes(egreso.estadoID) ? 1 : 2 : 2]">

              <strong>
                {{ egreso && estadoEgresoOptions.length ? estadoEgresoOptions.find(t => t.value ===
                  egreso.estadoID).text : '' }} </strong>
            </b-badge>
          </h3>
        </div>
      </b-card-header>

      <div class="d-flex">
        <h3 class="mb-0">{{ $t('egreso') }} #{{ egreso.id }} </h3>
      </div>

      <Loading v-if="loading" />

      <b-form v-else @submit.prevent="submitForm">
        <div class="d-flex justify-content-end mb-5">
          <b-button v-if="!isEditMode"
            @click="$router.push('/egresos/documentos/' + egreso.id)">
            <i class="far fa-file-image"></i> {{ $t('ver_documentos') }}
          </b-button>

          <template v-if="rol === 'admin'">
            <b-button @click="isEditMode = !isEditMode" :variant="!isEditMode ? 'info' : 'danger'">
              {{ !isEditMode ? $t('editar') : $t('cancelar') }}
            </b-button>

            <b-button v-if="isEditMode" :disabled="!isEditMode" type="submit" variant="primary" class="ml-2">
              {{ $t('actualizar') }}
            </b-button>
          </template>
        </div>
        <b-row v-if="rol === 'admin'">
          <b-col md="12">
            <b-row>
              <!--b-col md="2">
                <b-form-group :label="$t('tipo')">
                  <b-form-radio-group :disabled="!isEditMode" v-model="egreso.tipo" name="tipo" required>
                    <b-form-radio value="O">{{ $t('origen') }}</b-form-radio>
                    <b-form-radio value="D">{{ $t('destino') }}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col-->

              <b-col md="2">
                <b-form-group label-for="paisID">
                  <template v-slot:label>
                    {{ $t('pais') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="paisID" :disabled="!isEditMode" @change="onChangePais" v-model="egreso.paisID"
                    required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in paisOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label-for="fecha">
                  <template v-slot:label>
                    {{ $t('fecha') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="fecha" type="date" :disabled="!isEditMode" v-model="egreso.fecha"
                    required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label-for="acta">
                  <template v-slot:label>
                    {{ $t('numero_acta') }}
                  </template>
                  <b-form-input id="acta" type="number" :disabled="true" v-model="egreso.numeroActa" min="0"
                    :placeholder="$t('numero_acta')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>1. {{ $t('origen') }}</strong>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label-for="empresaID">
                  <template v-slot:label>
                    {{ $t('empresa') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="empresaID" :disabled="!isEditMode" v-model="egreso.empresaID"
                    @change="onEmpresaOrigenChange" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Origen" label-for="plantaOrigenID">
                  <template v-slot:label>
                    {{ $t('planta') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="plantaOrigenID" :disabled="!isEmpresaSelected || !isEditMode"
                    v-model="egreso.plantaOrigenID" @change="onPlantaOrigenChange" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in plantaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Origen" label-for="pasilloOrigenID">
                  <template v-slot:label>
                    {{ $t('pasillo') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="pasilloOrigenID" :disabled="!isPlantaSelected || !isEditMode"
                    v-model="egreso.pasilloOrigenID" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in pasilloOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>2. {{ $t('transporte_origen') }}</strong>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label-for="choferID">
                  <template v-slot:label>
                    {{ $t('chofer') }} <span class="text-danger">*</span>
                  </template>

                  <el-select class="custom-input" :disabled="!isEditMode" v-model="egreso.choferID" filterable
                    :placeholder="$t('seleccione_opcion')" style="width: 100%;">
                    <el-option v-for="item in choferOptions" :key="item.value" :label="item.text" :value="item.value" />
                  </el-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label-for="patente">
                  <template v-slot:label>
                    {{ $t('patente_camion') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="patente" :disabled="!isEditMode" v-model="egreso.patente" required
                    :placeholder="$t('ingrese_patente')"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label-for="patente">
                  <template v-slot:label>
                    {{ $t('patente_carro') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="patente" :disabled="!isEditMode" v-model="egreso.patenteCarro" required
                    placeholder="Ingrese la patente"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12">
            <b-row class="mb-2">
              <strong>3. {{ $t('destino') }}</strong>
            </b-row>
            <b-row>
              <b-col class="col-md-2">
                <b-form-group label="Empresa Destino" label-for="empresaDestinoID">
                  <template v-slot:label>
                    {{ $t('empresa') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="empresaDestinoID" :disabled="!isEditMode" v-model="egreso.empresaDestinoID"
                    @change="onEmpresaDestinoChange" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col class="col-md-2">
                <b-form-group label="Destino" label-for="plantaDestintoID">
                  <template v-slot:label>
                    {{ $t('planta') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="plantaDestintoID" :disabled="!isEmpresaDestinoSelected || !isEditMode"
                    v-model="egreso.plantaDestinoID" @change="onPlantaDestinoChange" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in plantaDestinoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col class="col-md-2">
                <b-form-group label="Destino" label-for="pasilloDestintoID">
                  <template v-slot:label>
                    {{ $t('pasillo') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="pasilloDestintoID" :disabled="!isPlantaDestinoSelected || !isEditMode"
                    v-model="egreso.pasilloDestinoID" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in pasilloDestinoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="7">
            <b-row class="mb-2">
              <strong>4. {{ $t('guia_despacho') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="guiaTraslado">
                  <template v-slot:label>
                    {{ $t('guia_traslado') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="guiaTraslado" :disabled="!isEditMode" v-model="egreso.guiaTraslado" required
                    :placeholder="$t('numero_acta')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="ingresoID">
                  <template v-slot:label>
                    {{ $t('ingreso') }}
                  </template>
                  <el-select :disabled="!isEditMode" v-model="egreso.ingresoID" filterable clearable
                    :placeholder="$t('seleccione_opcion')" style="width: 100%;">
                    <el-option v-for="item in ingresoOptions" :key="item.value" :label="item.text" :value="item.value" />
                  </el-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="montoGuiaTraslado">
                  <template v-slot:label>
                    {{ $t('monto_guia_traslado') }} 
                    <span v-if="monedaOptions.find(t => t.value === egreso.monedaID)">
                      ({{ monedaOptions.find(t => t.value === egreso.monedaID).text }})
                    </span>
                    <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="montoGuiaTraslado" :disabled="!isEditMode" v-model="egreso.montoGuiaTraslado"
                    type="number" step="any" required :placeholder="$t('monto_guia')">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="peso">
                  <template v-slot:label>
                    {{ $t('peso_neto') }}
                    <span v-if="uomOptions.find(t => t.value === egreso.uomID)">
                      ({{ uomOptions.find(t => t.value === egreso.uomID).text }})
                    </span>
                    <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="peso" :disabled="!isEditMode" :value="$utilsService.getFormattedDecimal('peso', egreso)"
                  @input="$utilsService.onInputDecimal('peso', egreso, $event)" required type="text"
                    step="any" :placeholder="$t('peso_neto')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="pesoTotal">
                  <template v-slot:label>
                    {{ $t('peso_total') }}
                    <span v-if="uomOptions.find(t => t.value === egreso.uomID)">
                      ({{ uomOptions.find(t => t.value === egreso.uomID).text }})
                    </span>
                    <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="pesoTotal" :disabled="!isEditMode"  :value="$utilsService.getFormattedDecimal('pesoTotal', egreso)"
                  @input="$utilsService.onInputDecimal('pesoTotal', egreso, $event)" required type="text"
                    step="any" :placeholder="$t('peso_total')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="5">
            <b-row class="mb-2">
              <strong>5. {{ $t('materiales') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="materialID">
                  <template v-slot:label>
                    {{ $t('material_despachado') }} <span v-if="isEditMode" style="color: red;"
                      class="text-danger">*</span>
                  </template>
                  <b-form-select id="materialID" :disabled="!isEditMode" v-model="egreso.materialID" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in materialOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="uomID">
                  <template v-slot:label>
                    {{ $t('uom') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="uomID" :disabled="!isEditMode" v-model="egreso.uomID" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in uomOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="8">
            <b-row class="mb-2">
              <strong>6. {{ $t('valor') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label="Precio" label-for="precio">
                  <template v-slot:label>
                    {{ $t('precio') }} 
                    <span v-if="monedaOptions.find(t => t.value === egreso.monedaID)">
                      ({{ monedaOptions.find(t => t.value === egreso.monedaID).text }})
                    </span>
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="precio" :value="$utilsService.getFormattedDecimal('precio', egreso)" @keypress="onlyNumbers"
                  @input="$utilsService.onInputDecimal('precio', egreso, $event)"  :disabled="!isEditMode"
                    :placeholder="$t('precio')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="monedaID">
                  <template v-slot:label>
                    {{ $t('moneda') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="monedaID" :disabled="!isEditMode" v-model="egreso.monedaID" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in monedaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="porcentaje">
                  <template v-slot:label>
                    {{ $t('porcentaje_producto') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="porcentaje" :disabled="!isEditMode" v-model="egreso.porcentajeProducto" required
                    placeholder="Ingrese la porcentaje"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="comentariosDescuento">
                  <template v-slot:label>
                    {{ $t('comentarios') }}
                  </template>
                  <b-form-textarea id="comentariosDescuento" :disabled="!isEditMode"
                    v-model="egreso.comentariosDescuento" :placeholder="$t('comentarios_descuento')"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="estadoPagoID">
                  <template v-slot:label>
                    {{ $t('estado_pago') }}
                  </template>
                  <b-form-select id="estadoPagoID" :disabled="!isEditMode" v-model="egreso.estadoPagoID">
                    <option :value="null">{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in estadoPagoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="estadoID">
                  <template v-slot:label>
                    {{ $t('estado') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="estadoID" :disabled="!isEditMode" v-model="egreso.estadoID" required>
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in estadoEgresoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!--/b-row-->
      </b-form>
    </base-header>
  </div>
</template>

<script>
import egresoService from '@/api/egresoService';
import utilsService from '@/api/utilsService';
import Loading from '@/components/Loading.vue';
import miscService from '@/api/miscService';
import actaService from '@/api/actaService';
import Swal from 'sweetalert2';
import { Select, Option } from 'element-ui'

export default {
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      isEditMode: false,
      egreso: {},
      materialOptions: [],
      empresaOptions: [],
      choferOptions: [],
      estadoEgresoOptions: [],
      estadoPagoOptions: [],
      uomOptions: [],
      monedaOptions: [],
      paisOptions: [],
      plantaOptions: [],
      ingresoOptions: [],
      plantaDestinoOptions: [],
      pasilloOptions: [],
      pasilloDestinoOptions: [],
      isEmpresaSelected: false,
      isEmpresaDestinoSelected: false,
      isPlantaSelected: false,
      isPlantaDestinoSelected: false,
      loading: true,
      isValidActa: false,
      isValidFolioInit: false
    };
  },
  computed: {
    rol() {
      return utilsService.getRol();
    }
  }, async beforeMount() {
    await this.initData();
  },
  methods: {
    async initData() {
      const id = this.$route.params.id;

      const promises = [
        egresoService.get(id),
        miscService.getEstadoPagosOptions(),
        miscService.getEstadosOptions(),
        miscService.getChoferesOptions(),
        miscService.getMaterialesOptions(),
        miscService.getMonedasOptions(),
        miscService.getUomsOptions(),
        miscService.getPaisesOptions(),
        miscService.getIngresosOptions()
      ];
      const [
        egreso,
        estadoPagoOptions,
        estadoEgresoOptions,
        choferOptions,
        materialOptions,
        monedaOptions,
        uomOptions,
        paisOptions,
        ingresoOptions
      ] = await Promise.all(promises);

      this.egreso = egreso;
      this.estadoPagoOptions = estadoPagoOptions;
      this.estadoEgresoOptions = estadoEgresoOptions;
      this.choferOptions = choferOptions;
      this.materialOptions = materialOptions;
      this.monedaOptions = monedaOptions;
      this.uomOptions = uomOptions;
      this.paisOptions = paisOptions;
      this.ingresoOptions = ingresoOptions;

      if (this.egreso.precio > 999)
        this.egreso.precio = this.egreso.precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (this.egreso.pesoTotal > 999)
        this.egreso.pesoTotal = this.egreso.pesoTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      if (this.egreso.montoGuiaTraslado > 999)
        this.egreso.montoGuiaTraslado = this.egreso.montoGuiaTraslado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      if (this.rol === "admin" && this.egreso) {
        this.empresaOptions = await miscService.getEmpresasOptions();
        if (this.egreso.empresaID > 0)
          this.plantaOptions = await miscService.getPlantasByEmpresaOptions(this.egreso.empresaID);
        if (this.egreso.empresaDestinoID > 0)
          this.plantaDestinoOptions = await miscService.getPlantasByEmpresaOptions(this.egreso.empresaDestinoID);

        if (this.egreso.plantaOrigenID > 0 && this.egreso.empresaID > 0)
          this.pasilloOptions = await miscService.getPasillosByEmpresaOptions(this.egreso.empresaID, this.egreso.plantaOrigenID);

        if (this.egreso.plantaDestinoID > 0 && this.egreso.empresaDestinoID > 0)
          this.pasilloDestinoOptions = await miscService.getPasillosByEmpresaOptions(this.egreso.empresaDestinoID, this.egreso.plantaDestinoID);

        this.isPlantaSelected = this.egreso.plantaOrigenID > 0;
        this.isPlantaSelected = this.egreso.plantaDestinoID > 0;
        this.isEmpresaSelected = true;
        this.isEmpresaDestinoSelected = this.egreso.empresaDestinoID > 0;
      }
      this.isValidActa = this.egreso.numeroFolio > 0;
      this.loading = false;

    },
    async onEmpresaOrigenChange() {
      const empresa = this.egreso.empresaID;
      this.egreso.pasilloOrigenID = null;
      this.egreso.plantaOrigenID = null;
      if (empresa) {
        this.plantaOptions = await miscService.getPlantasByEmpresaOptions(empresa);
        this.isEmpresaSelected = true;
      } else {
        this.plantaOptions = [];
        this.isEmpresaSelected = false;
      }
    },
    async onEmpresaDestinoChange() {
      const empresa = this.egreso.empresaDestinoID;
      this.egreso.pasilloDestinoID = null;
      this.egreso.plantaDestinoID = null;
      if (empresa) {
        this.plantaDestinoOptions = await miscService.getPlantasByEmpresaOptions(empresa);
        this.isEmpresaDestinoSelected = true;
      } else {
        this.plantaOptions = [];
        this.isEmpresaDestinoSelected = false;
      }
    },
    async onChangePais() {

      this.egreso.pasilloDestinoID = null;
      this.egreso.plantaDestinoID = null;
      this.egreso.pasilloOrigenID = null;
      this.egreso.plantaOrigenID = null;
      this.egreso.empresaID = null;
      this.egreso.empresaDestinoID = null;
      this.isEmpresaDestinoSelected = false;
      this.isPlantaSelected = false;
      this.isPlantaDestinoSelected = false;
      this.isEmpresaSelected = false;
      this.empresaOptions = await miscService.getEmpresasByPaisOptions(this.egreso.paisID);
    },
    async onPlantaOrigenChange() {
      const empresa = this.egreso.empresaID;
      const planta = this.egreso.plantaOrigenID;
      if (empresa && planta) {
        this.pasilloOptions = await miscService.getPasillosByEmpresaOptions(empresa, planta);
        this.isPlantaSelected = true;
      } else {
        this.pasilloOptions = [];
        this.isPlantaSelected = false;
      }
    },
    async generarActa() {
      Swal.fire({
        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Generando Acta...</h3>
                        </div>
                    </div>`,
        showConfirmButton: false,
        allowOutsideClick: false
      });

      try {

        const resp = await actaService.getActa(this.egreso.id);
        Swal.close();
        await this.initData()

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error,
        });
      }

    },
    async onPlantaDestinoChange() {
      const empresa = this.egreso.empresaDestinoID;
      const planta = this.egreso.plantaDestinoID;
      if (empresa && planta) {
        this.pasilloDestinoOptions = await miscService.getPasillosByEmpresaOptions(empresa, planta);
        this.isPlantaDestinoSelected = true;
      } else {
        this.pasilloDestinoOptions = [];
        this.isPlantaDestinoSelected = false;
      }
    },
    async submitForm() {

      Swal.fire({
        title: this.$t('estas_seguro'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            if (this.egreso.empresaID == this.egreso.empresaDestinoID) {
              this.$toast.error('La Empresa de origen no puede ser igual a la de Destino.', {
                position: 'top-center',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true
              });
              Swal.close();
              return;
            }

            if (this.egreso.pasilloDestinoID == this.egreso.pasilloOrigenID) {
              this.$toast.error('El Pasillo de origen no puede ser igual al de Destino.', {
                position: 'top-center',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true
              });
              Swal.close();
              return;
            }
            await egresoService.update(this.egreso, this.egreso.id);
            await this.initData()
            this.isEditMode = false;
            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });

          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error,
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    },
    onlyNumbers(event) {
      // Solo permite números (0-9)
      if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete') {
        event.preventDefault();
      }
    }
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
